import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { queryMiddleware } from 'redux-query';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';

import createGlobalReducer from './global-reducer';
import globalSagas from './global-sagas';
import { getQueries, getEntities } from './global-selectors';
import { proxyInterface } from './utils/query';

const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

const middlewares = [
  // Middleware for intercepting and dispatching navigation actions
  routerMiddleware(history),
  queryMiddleware(proxyInterface, getQueries, getEntities, {
    backoff: {
      maxAttempts: 1
    }
  }),
  thunkMiddleware,
  sagaMiddleware,
];

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */

const persistConfig = {
  blacklist: ['queries', 'entities', 'errors', 'router', 'serviceConfig'],
  key: 'root',
  storage,
};

const rootReducer = createGlobalReducer(history);
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middlewares)),
);

export const persistor = persistStore(store);
sagaMiddleware.run(globalSagas);

export default store;
